module.exports = __webpack_public_path__ + "static/images/money.aa1a2c195cdc68d0cb9e53e8445fea72.svg";